import ieqipCoreServiceApi from './ieqipCoreServiceApi';

const BASE = '/api/aiassistantchats';

export const listChatsByUser = async (userId) => {
    const response = await ieqipCoreServiceApi.get(`${BASE}/user_id/${encodeURIComponent(userId)}`);
    return response.data;
};

export const listChatMessages = async (chatUid) => {
    const response = await ieqipCoreServiceApi.get(`${BASE}/${chatUid}/messages`);
    return response.data;
};

export const createChat = async ({ userId, scopes }) => {
    const response = await ieqipCoreServiceApi.post(BASE, {
        user_id: userId,
        is_active: 1,
        created_date: null,
        created_by: userId,
        scopes,
    });
    return response.data;
};

export const saveChatMessage = async ({ chatId, userId, userName, message, citations = '', commodity = null, market = null, openaiResponseId = null, isAssistant = false }) => {
    const response = await ieqipCoreServiceApi.post(`${BASE}/messages`, {
        ai_assistant_chat_id: chatId,
        message,
        citations,
        user_id: isAssistant ? 'assistant' : userId,
        user_name: isAssistant ? 'AI Assistant' : userName,
        user_avatar: '',
        is_active: 1,
        created_date: null,
        created_by: null,
        openai_response_id: openaiResponseId,
        commodity,
        market,
    });
    return response.data;
};

export const deleteChat = async (chatUid) => {
    const response = await ieqipCoreServiceApi.delete(`${BASE}/${chatUid}`);
    return response.data;
};
